import React from 'react';
import { Image, Header, Text, Visibility } from '@gasbuddy/react-components';
import { Banner } from '../Banner';
import AppSMSInput from '../AppSMSInput';
import { BRANCH_IO_KEY, ANALYTICS_EVENTS } from '../../constants';
import { localyticsEvent } from '../../../lib/utils';

import style from './InlineBanners.module.css';

export default function OnTheGoBanner() {
  return (
    <Banner backgroundImage="https://static.gasbuddy.com/web/consumer/download-app-large-2.png" dramatic container>
      <div className={style.gbOnGoContent}>
        <Header as="h2" className={style.header}>
          <span className={style.onTheGoHeader}>GasBuddy On The Go.</span>
          <Text className={style.subHeader}>
            Report prices, read reviews, fun challenges and gas giveaways.
            All in the app for iPhone and Android.
          </Text>
        </Header>
        <AppSMSInput branchKey={BRANCH_IO_KEY} />
        <Visibility mobile={false}>
          <div className={style.imageGroupContainer}>
            <a href="https://apps.apple.com/us/app/gasbuddy-find-cheap-gas-prices/id406719683?mt=8">
              <Image
                src="https://static.gasbuddy.com/web/pay/svg/cta/apple-store-badge.svg"
                alt="Apple Store Badge Button"
                title="Apple Store Badge Button"
                onClick={() => localyticsEvent(ANALYTICS_EVENTS.APP_STORE_LINK_CLICK, { Store: 'PlayStore', 'Screen Name': 'Brand_Page', Section: 'AppPromo' })}
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=gbis.gbandroid">
              <Image
                src="https://static.gasbuddy.com/web/pay/svg/cta/play-store-badge.svg"
                alt="Google Play Store Badge Button"
                title="Google Play Store Badge Button"
                onClick={() => localyticsEvent(ANALYTICS_EVENTS.APP_STORE_LINK_CLICK, { Store: 'iTunes', 'Screen Name': 'Brand_Page', Section: 'AppPromo' })}
              />
            </a>
          </div>
        </Visibility>
      </div>
    </Banner>
  );
}
